// @flow
import { push } from 'react-router-redux';
import moment from 'moment';

import { setFitBounds } from 'actions/map';

import fetch from 'utils/fetch';
import { formatMinutesAsTime } from 'utils/datetime';

import { INITIAL_STATE } from 'reducers/geocoder';

const AC_KM_RADIUS = 50;

export const GEOCODER_LOAD_COMPLETIONS = 'geocoder/LOAD_COMPLETIONS';

function getMatchingAircrafts(getState, query) {
  const {
    rt: { features },
  } = getState();

  return features
    .filter(({ properties }) =>
      ['name', 'id'].some(
        key =>
          key in properties &&
          String(properties[key])
            .toLowerCase()
            .indexOf(query.toLowerCase()) >= 0
      )
    )
    .map(({ properties: { name }, id }) => ({
      key: id,
      description: name || id,
    }))
    .slice(0, 5);
}

export function loadCompletions(query) {
  return (dispatch, getState) => {
    if (!query) {
      dispatch({
        type: GEOCODER_LOAD_COMPLETIONS,
        query,
        completions: INITIAL_STATE.completions,
      });
    }
    const {
      map: {
        viewport: { center },
      },
      filters: { dateRange, timeRange },
    } = getState();

    if (!query) {
      dispatch({
        type: GEOCODER_LOAD_COMPLETIONS,
        query,
        completions: INITIAL_STATE.completions,
      });
      return;
    }

    fetch(
      [
        '/api/v1/geocode/ac',
        ...center,
        AC_KM_RADIUS,
        moment(dateRange.min)
          .startOf('day')
          .unix(),
        moment(dateRange.max)
          .endOf('day')
          .unix(),
        formatMinutesAsTime()(timeRange.min),
        formatMinutesAsTime()(timeRange.max),
        encodeURIComponent(query),
      ].join('/')
    )
      .then(response => response && response.json())
      .then(completions => {
        if (completions) {
          const ac = getMatchingAircrafts(getState, query);
          dispatch({
            type: GEOCODER_LOAD_COMPLETIONS,
            query,
            completions: { ...completions, ac },
          });
        } else {
          dispatch({
            type: GEOCODER_LOAD_COMPLETIONS,
            query,
            completions: INITIAL_STATE.completions,
          });
        }
      })
      .catch(() => {
        dispatch({
          type: GEOCODER_LOAD_COMPLETIONS,
          query,
          completions: INITIAL_STATE.completions,
        });
      });
  };
}

export function localize(query) {
  return dispatch => {
    try {
      const {
        value: {
          props: { value: acResult },
        },
      } = query;

      // Aircrafts do not need to be localized
      if (acResult.result_type === 'ac') {
        dispatch(push(`/ac/${acResult.key}`, { pan: true }));
        return;
      }

      fetch(
        `/api/v1/geocode/localize/${acResult.result_type}/${encodeURIComponent(
          acResult.key
        )}`
      )
        .then(response => response.json())
        .then(result => {
          if (acResult.result_type === 'gmp') {
            dispatch(setFitBounds(result.bbox));
          } else {
            dispatch(
              push(`/${acResult.result_type}/${acResult.key}`, { pan: true })
            );
          }
        });
    } catch (e) {}
  };
}



// WEBPACK FOOTER //
// ./actions/geocoder.js